module.exports = __webpack_public_path__ + "img/snapsuite-icon.e2025b2e.png";